import { Routes, Route } from "react-router-dom";
import Layout from "../components/layout";
import HomePage from "../pages/homepage";
import Apropos from "../pages/apropos";
import Articles from "../pages/articles";
import DetailProduct from "../pages/detailproduct";
import CartPage from "../pages/cart";
import Success from "../pages/success";
import Cancel from "../pages/cancel";
import Conditiongeneral from "../pages/conditiongeneral";
import UniquePiece from "../pages/uniquepiece";
import UniquePieceDetail from "../pages/uniquepiecedetail";
import Evenement from "../pages/event";

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="articles" element={<Articles />} />
        <Route path="a-propos" element={<Apropos />} />
        <Route path="evenements" element={<Evenement />} />
        <Route path="product/:id" element={<DetailProduct />} />
        <Route path="/uniquepiece" element={<UniquePiece />} />
        <Route path="/uniquepiece/:slug" element={<UniquePieceDetail />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="conditions-générales" element={<Conditiongeneral />} />

        <Route path="/success" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />
      </Route>
    </Routes>
  );
};

export default AppRouter;
